




































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ListViewItem from "./listviewitem";

@Component({
  name: "ui-list-view-item"
})
export default class UIListViewItem extends Vue {
  @Prop({ default: null, type: String })     title!: String;
  // параметры
  @Prop({ default: null, type: Object })      item!: ListViewItem<any>;
  @Prop({ default: false, type: Boolean })   multi!: Boolean;
  @Prop({ default: "box", type: String })  typeView: String;
  @Prop({ default: true, type: Boolean }) selected!: Boolean;
  @Prop({ default: true, type: Boolean })  hovered!: Boolean;
  @Prop({ default: true, type: Boolean }) disabled!: Boolean;
  @Prop({ default: true, type: Boolean }) selectAccess!: Boolean;

  innerTypeView = this.typeView;
  hover: boolean = false;


  // методы
  created(){

  }

  mouseover() {
    if (this.hovered) this.hover = true;
  }
  mouseleave() {
    if (this.hovered) this.hover = false;
  }
  click(value: any) {
    if (!this.item.Disabled && this.selectAccess) {
      this.item.Selected = !this.item.Selected;
      this.$emit("select", this.item);
    }
  }
  isHover() {
    // debugger
    return this.hover && !this.isDisabled() 
  }
  isSelected() {
    return (
      !this.isHover() && this.item.Selected 
    );
  }
  isDisabled() {
    return this.item.Disabled 
  }
  isDefault() {
    
    return !this.isHover() && !this.isSelected() 
  }
  currentClass(){
    if (this.hover) return "hover"
    if (this.item.Selected) return "selected"
  }
  dragStart(value: DragEvent) {
    if (this.item.Disabled) {
      return;
    }
    value.dataTransfer.effectAllowed = "move";
    value.dataTransfer.setData(
      "application/x-javascript",
      JSON.stringify(this.item)
    );
    this.$emit("itemDragStart", this.item, value);
  }

  dragEnd(value: any) {    
    this.$emit("itemdropend", this.item, value);
  }
  dragDrop(value: any) {
    value.preventDefault();
    this.$emit("itemdrop", this.item, value);
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/ui-components/~/list-view/src/ui-list-view-item.vue